import { Button, Col, Row, Statistic } from "antd";
import React from "react";
// import AboutTopImg from "../../../../assets/images/about1.png";
import AboutTopImg from "../../../../assets/images/aboutImg.png";
import AboutBottomImg from "../../../../assets/images/aboutUsimg.png";
import QrCode from "../../../../assets/images/icon/QR.svg";
import { ReactComponent as ArrowRight } from "../../../../assets/images/icon/backToTop.svg";
// import { ReactComponent as Star } from "../../../../assets/images/icon/Star.svg";
import type { StatisticProps } from 'antd';
import CountUp from 'react-countup';

const formatter: StatisticProps['formatter'] = (value) => (
    <CountUp end={value as number} separator="," />
);
const AboutUs: React.FC<any> = () => {
    return (
        <>
            <section className="section aboutSection" id="aboutus">
                <Row>
                    <Col span={13} xs={{ span: 12, order: 2 }} md={{ span: 12, order: 1 }} xl={{ span: 12, order: 1 }}>
                        <div className="imgWrap">
                            <Row className="aboutTop">
                                <Col span={18}>
                                    <div className="aboutTopImg">
                                        <img src={AboutTopImg} alt="about us image" />
                                        <div className="aboutText">
                                            About
                                        </div>
                                    </div>

                                </Col>
                                <Col span={4}>
                                    <div className="qrCodeImg">
                                        <div className="rounded-text rotating">
                                            <svg viewBox="0 0 200 200">
                                                <path id="textPath" d="M 85,0 A 85,85 0 0 1 -85,0 A 85,85 0 0 1 85,0" transform="translate(100,100)" fill="none" strokeWidth="0"></path>
                                                <g fontSize="13.1px">
                                                    <text textAnchor="start">
                                                        <textPath className="coloring" xlinkHref="#textPath" startOffset="0%"> &#10036; Scan & Download &#10036; Scan & Download  &#10036; Scan & Download </textPath>
                                                    </text>
                                                </g>
                                            </svg>
                                        </div>
                                        <img src={QrCode} alt="about us qr code" />
                                    </div>

                                </Col>
                            </Row>

                            <Row className="aboutBottom">
                                <Col span={12}>
                                    <div className="aboutTopImg">
                                        <img src={AboutBottomImg} alt="about us image" />
                                        <div className="aboutText">
                                            us
                                        </div>
                                    </div>


                                </Col>
                            </Row>
                        </div>
                    </Col>

                    <Col span={7} xs={{ span: 12, order: 1 }} md={{ span: 8, order: 2 }} xl={{ span: 8, order: 2 }}>
                        <div className="aboutContent">
                            <h2 className="headerFonts">
                                This is how the <span>kapturely</span> works!
                            </h2>
                            <p>
                                As an easy-to-use mobile app, kapturely helps exhibitors or participants capture and organize leads
                                quickly at the event. As kapturely organizes leads effectively, you can focus on building relationships
                                and closing deals. It has optimized, user-friendly interface and other necessary features to organize
                                hundreds of leads easily. Kapturely assists you to transform leads from capture to conversion.
                            </p>
                            <div className="aboutAlign">
                                {/* <h2>
                                    500+
                                    <span>Delighted
                                        Clients</span>
                                </h2>
                                <span className="beforeIcon"></span>
                                <h2>
                                    21+
                                    <span>Industry
                                        Experience</span>
                                </h2> */}


                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Statistic title="Delighted
                                        Clients" value={500} formatter={formatter} />
                                    </Col>
                                    <Col span={12}>
                                        <Statistic title="Industry
                                        Experience" value={21} precision={2} formatter={formatter} />
                                    </Col>
                                </Row>

                            </div>
                            <div className="aboutBtn">
                                <Button className="commanBtn" htmlType="submit">
                                    <span className="arrowIcon">
                                        <ArrowRight />
                                    </span>
                                    <span className="beforeIcon"></span>
                                    Read More
                                </Button>
                            </div>
                        </div>
                    </Col>
                    {/* </div> */}
                </Row>

            </section>
        </>
    );
};

export default AboutUs;
